import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";

import Themes from "./themes";
import "./pages/dashboard/dashboardTableHover.css";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import { AlertProvider } from "./context/AlertContext";

let hasPendingReload = false;

ReactDOM.render(
  <LayoutProvider>
    <UserProvider>
      <ThemeProvider theme={Themes.default}>
        <CssBaseline />
        <AlertProvider>
          <App />
        </AlertProvider>
      </ThemeProvider>
    </UserProvider>
  </LayoutProvider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: (registration) => {
    try {
      // Activate new service worker immediately.
      if (registration?.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    } catch (e) {
      // Fallback reload still handles update.
    }

    // Fallback: force one reload if controller change is slow.
    if (!hasPendingReload) {
      hasPendingReload = true;
      setTimeout(() => {
        window.location.reload();
      }, 1200);
    }
  },
});

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  // Reload exactly once when the updated SW starts controlling the page.
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hasPendingReload) {
      hasPendingReload = true;
      window.location.reload();
    }
  });

  // Poll for updates periodically so users get new deploys quickly.
  navigator.serviceWorker.ready
    .then((registration) => {
      const checkForUpdate = () => registration.update().catch(() => {});
      checkForUpdate();
      setInterval(checkForUpdate, 60 * 1000);
    })
    .catch(() => {});
}
